export const APPEND_NEW_STORE_RATING = 'APPEND_NEW_STORE_RATING';
export const APPEND_NEW_STORE_RATING_SUCCESS = `${APPEND_NEW_STORE_RATING}_SUCCESS`;
export const APPEND_NEW_STORE_RATING_FAIL = `${APPEND_NEW_STORE_RATING}_FAIL`;

const AverageinitialState = {
  error: {},
  items: {},
};
const AverageReducer = (state = AverageinitialState, action = {}) => {
  /* eslint-disable */
    let items;
    let error;
    switch (action.type) {
        case APPEND_NEW_STORE_RATING:
            items = {
                ...state.items
            }
            items[action.payload.store] = {
                isLoading: true,
                data: null
            }
            return {
                ...state,
                items,
            }
        case APPEND_NEW_STORE_RATING_SUCCESS:
            items = {
                ...state.items
            }
            items[action.payload.store] = {
                isLoading: false,
                data: action.payload.data
            }
            return {
                ...state,
                items,
            }
        case APPEND_NEW_STORE_RATING_FAIL:
            items = {
                ...state.items
            }
            error = {
                ...state.error
            }
            items[action.payload.store] = {
                isLoading: false,
                data: null
            }
            error[action.payload.store] = action.payload.error
            return {
                ...state,
                items,
                error,
            }
        default:
            return state;

    }
}

export default AverageReducer;
